<template>
  <div class="information-exposure">
    <section class="menus">
      <router-link
        v-for="menu in menus"
        :key="menu.path"
        :to="menu.path"
        :class="{ active: currentPath === menu.path }"
      >
        {{ menu.name }}
      </router-link>
    </section>
    <section class="menus--mobile">
      <section class="menus-control" @click="collapse = !collapse">
        <img
          src="https://static.soyoung.com/sy-pre/menu off-1682651400726.svg"
          alt=""
        />
      </section>
      <section class="menu-draw-container" :class="{ hide: collapse }">
        <section class="mask" @click="collapse = !collapse"></section>
        <section class="menus--sider">
          <router-link
            v-for="menu in menus"
            :key="menu.path"
            :to="menu.path"
            :class="{ active: currentPath === menu.path }"
          >
            {{ menu.name }}
          </router-link>
        </section>
      </section>
    </section>
    <section class="content">
      <router-view></router-view>
    </section>
  </div>
</template>

<script>
export default {
  name: "information-exposure",
  data() {
    const base = "/information_exposure";
    return {
      menus: [
        {
          name: "公司概况",
          path: base + "/company_information",
        },
        {
          name: "官方公告",
          path: base + "/official_notices",
        },
        {
          name: "经营资质",
          path: base + "/certifications",
        },
        {
          name: "保险产品",
          path: base + "/insurance_products",
        },
        {
          name: "合作保险公司",
          path: base + "/cooperative_insurance_companies",
        },
        {
          name: "合作中介机构",
          path: base + "/cooperative_agents",
        },
        {
          name: "合作网络平台",
          path: base + "/cooperative_platforms",
        },
      ],
      collapse: true,
    };
  },
  watch: {
    "$route.path": function() {
      this.collapse = true;
    },
  },
  computed: {
    currentPath() {
      return this.$route.path;
    },
  },
};
</script>

<style lang="less">
.information-exposure {
  padding-top: 90px;
  background: #f6fafe;
  .menus {
    position: fixed;
    top: 60px;
    left: 0;
    right: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 32px 0;
    background: #f6fafe;
    z-index: 3;
    a {
      display: inline-block;
      font-size: 14px;
      color: #53595f;
      line-height: 20px;
      text-decoration: none;
      padding: 4px 16px;
      flex-shrink: 0;
      cursor: pointer;
      &.active {
        color: #ffffff;
        font-weight: bold;
        background: #0044c1;
        border-radius: 32px 32px 32px 0;
      }
    }
    a + a {
      margin-left: 12px;
    }
  }
  & > .content {
    padding: 60px 0;
    .module__header {
      padding-bottom: 40px;
    }
  }
  .menus--mobile {
    display: none;
  }
}
@media all and (max-width: 1200px) {
  .information-exposure {
    padding-top: 0;
    .menus {
      display: none;
    }
    .menus--mobile {
      display: block;
      .menus-control {
        width: 24px;
        height: 24px;
        position: fixed;
        right: 10px;
        top: 10px;
        z-index: 1000000;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .menu-draw-container {
        position: fixed;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        display: flex;
        justify-content: space-between;
        z-index: 1000000;
        .mask {
          flex: auto;
          background: rgba(0, 0, 0, 0.4);
          height: 100%;
        }
        .menus--sider {
          width: 180px;
          background: #ffffff;
          box-sizing: border-box;
          a {
            display: block;
            font-size: 16px;
            color: #53595f;
            line-height: 2;
            text-decoration: none;
            padding: 4px 16px;
            flex-shrink: 0;
            cursor: pointer;
            &.active {
              color: #ffffff;
              font-weight: bold;
              background: #0044c1;
            }
          }
        }
      }
    }
  }
}
</style>
